import VadImage from "vadimages-nextjs-image-optimizer";

const Divider = () => {
  return (
    <VadImage
      src={`/images/@global/horizontal-rule.png`}
      alt={`-`}
      width={200}
      height={2}
      className="mx-auto py-6"
    />
  );
};

export default Divider;
